export default __webpack_public_path__ + "static/screeny-130-ga-1-9cada4a3038f49f44023d8ce2a8b5247.jpg";